import React from 'react';
import { Link } from 'react-router-dom';
import { CITY_GUIDES, topRated } from '../data/guide';
import { SHOP_PRODUCTS } from '../data/shop';
import { formatPrice } from '../data/smaken';
import { Reveal } from '../components/Reveal';
import { Rating } from '../components/Rating';
import { Note, ArrowMark } from '../components/Marks';
const topProducts = SHOP_PRODUCTS.filter(p => p.stamp).slice(0, 3);
export function Guide() {
  const best = topRated(4);
  return <div data-id="element-927" data-mp="8rx72mggu7mu">
      <div className="mx-auto max-w-page px-5 pb-14 pt-10 md:px-8 md:pt-14" data-id="element-928" data-mp="8s72ipka56zx">
        <Reveal data-id="element-929" data-mp="8q48zvjx4vqg">
          <p className="text-[11px] font-bold uppercase tracking-wide3 text-rod" data-id="element-930" data-mp="mj2be1us3o3i">Guiden</p>
          <h1 className="display-xl mt-3 text-[3rem] uppercase leading-[0.9] sm:text-[4.5rem]" data-id="element-931" data-mp="hk908g2ys96i">
            Vi vet var du ska äta.
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-black/70" data-id="element-932" data-mp="wib4kshtkyot">
            Ingen algoritm, inga sponsrade placeringar. Vi har varit på varje ställe och betalat för maten
            själva.
          </p>
        </Reveal>
      </div>

      {/* Cities */}
      <section aria-labelledby="stader" className="border-y border-black/12" data-id="element-933" data-mp="1ijn9t0k9g911">
        <div className="mx-auto max-w-page px-5 py-14 md:px-8 md:py-16" data-id="element-934" data-mp="1mlqn7uqhpnoy">
          <h2 id="stader" className="display-xl text-4xl uppercase sm:text-5xl" data-id="element-935" data-mp="1mkfkzzcp0nzy">
            Vart är du på väg?
          </h2>

          <div className="mt-10 grid gap-x-8 gap-y-12 sm:grid-cols-2" data-id="element-936" data-mp="1wjy3ebcyg1pw">
            {CITY_GUIDES.map((guide, i) => <Reveal key={guide.city} delay={Math.min(i * 0.06, 0.18)} data-id="element-937" data-mp="21ihqwg775lkd" data-mpi={i}>
                <Link to={`/guide/${guide.city.toLowerCase()}`} className="group block border-t-2 border-black pt-4" data-id="element-938" data-mp="269px73d8cqtb">
                  <div className="aspect-[16/10] overflow-hidden bg-black/5" data-id="element-939" data-mp="2abup9xo15fdu">
                    <img src={guide.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-[280ms] ease-out group-hover:scale-[1.03]" data-id="element-940" data-mp="2fafrg2mue94x" />
                  </div>
                  <h3 className="display-xl mt-4 text-3xl uppercase transition-colors duration-150 ease-out group-hover:text-rod sm:text-4xl" data-id="element-941" data-mp="f8g5vy5b05pk">
                    {guide.city}
                  </h3>
                  <p className="mt-2 leading-relaxed text-black/65" data-id="element-942" data-mp="p6m86gv0vduy">{guide.strap}</p>
                </Link>
              </Reveal>)}
          </div>
        </div>
      </section>

      {/* Our highest rated */}
      <section aria-labelledby="hogst" className="bg-black text-papper" data-id="element-943" data-mp="ywxc43ephn1u">
        <div className="mx-auto max-w-page px-5 py-16 md:px-8 md:py-20" data-id="element-944" data-mp="1cvx3hitlsg1p">
          <Reveal data-id="element-945" data-mp="1ctubit8w4cuc">
            <h2 id="hogst" className="display-xl text-4xl uppercase sm:text-6xl" data-id="element-946" data-mp="17wu4og47v626">
              Högst betyg just nu
            </h2>
            <Note className="mt-3 block text-smor" data-id="element-947" data-mp="3emia2palac3s">Vår åsikt, inte deras.</Note>
          </Reveal>

          <ul className="mt-12 divide-y divide-papper/20 border-y border-papper/20" data-id="element-948" data-mp="39p04n8vs6f0j">
            {best.map(({
            place,
            verdict
          }, i) => <Reveal key={place.slug} delay={Math.min(i * 0.05, 0.15)} data-id="element-949" data-mp="1p6xzxcm242c5" data-mpi={i}>
                <li data-id="element-950" data-mp="1u3xy71co00sp">
                  <Link to={`/plats/${place.slug}`} className="group grid items-center gap-5 py-6 sm:grid-cols-[6rem,minmax(0,1fr),auto]" data-id="element-951" data-mp="1u4hdsbeued3k">
                    <img src={place.image} alt="" loading="lazy" className="hidden h-24 w-24 object-cover sm:block" data-id="element-952" data-mp="1kdmvfi4pvxne" />
                    <div data-id="element-953" data-mp="whigpzk8n355">
                      <p className="font-display text-2xl uppercase transition-colors duration-150 ease-out group-hover:text-smor" data-id="element-954" data-mp="wiabx99xayuw">
                        {place.name}
                      </p>
                      <p className="mt-1 text-[11px] font-bold uppercase tracking-wide2 text-papper/50" data-id="element-955" data-mp="2qv09c0zi2q71">
                        {place.city} · {place.tags.join(' · ')}
                      </p>
                      <p className="mt-2 max-w-xl leading-relaxed text-papper/75" data-id="element-956" data-mp="vsveo01qlccq">{verdict.verdict}</p>
                      <p className="mt-2 font-hand text-xl text-smor" data-id="element-957" data-mp="rq8khshlffcd">Beställ: {verdict.order}</p>
                    </div>
                    <span className="inline-flex items-center gap-1.5 justify-self-start sm:justify-self-end" data-id="element-958" data-mp="mqdr9iacido5">
                      <span className="display-xl text-4xl text-smor" data-id="element-959" data-mp="hs2fh20hpt3a">
                        {verdict.rating.toString().replace('.', ',')}
                      </span>
                      <span className="text-[11px] uppercase tracking-wide2 text-papper/45" data-id="element-960" data-mp="82ivft11jt6u">/ 5</span>
                    </span>
                  </Link>
                </li>
              </Reveal>)}
          </ul>
        </div>
      </section>

      {/* Top products */}
      <section aria-labelledby="toppprodukter" className="mx-auto max-w-page px-5 py-16 md:px-8 md:py-20" data-id="element-961" data-mp="3q84a1c2okfx4">
        <Reveal data-id="element-962" data-mp="3l8ssi0uhp6eh">
          <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-963" data-mp="3lac7lo4etbeo">
            <div data-id="element-964" data-mp="3b5mb3xrryzhu">
              <h2 id="toppprodukter" className="display-xl text-4xl uppercase sm:text-6xl" data-id="element-965" data-mp="3b65nz02kixp0">
                Topplistan
              </h2>
              <Note className="mt-3 block" data-id="element-966" data-mp="3g2mbpt5uva1k">Det vi köper själva, om och om igen.</Note>
            </div>
            <Link to="/butik" className="group flex items-center gap-2 text-[12px] font-bold uppercase tracking-wide2 transition-colors duration-150 ease-out hover:text-rod" data-id="element-967" data-mp="3l1h0rcuf1uu4">
              Handla allt
              <ArrowMark className="h-4 w-9 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-968" data-mp="2xdfz8nvnneo7" />
            </Link>
          </div>
        </Reveal>

        <ol className="mt-12 grid gap-x-8 gap-y-12 sm:grid-cols-3" data-id="element-969" data-mp="32b7pldgnisqa">
          {topProducts.map((product, i) => <Reveal key={product.id} delay={Math.min(i * 0.06, 0.18)} data-id="element-970" data-mp="29omyme438in9" data-mpi={i}>
              <li className="border-t-2 border-black pt-4" data-id="element-971" data-mp="29makkc1gasfh">
                <span className="display-xl block text-5xl text-rod" data-id="element-972" data-mp="2emg4f61hban0">0{i + 1}</span>
                <Link to="/butik" className="group mt-4 block" data-id="element-973" data-mp="26m0c6plrmzzg">
                  <div className="aspect-[4/3] overflow-hidden bg-black/5" data-id="element-974" data-mp="26kfi113d5j24">
                    <img src={product.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-[280ms] ease-out group-hover:scale-[1.03]" data-id="element-975" data-mp="21nfccrafeibj" />
                  </div>
                  <h3 className="mt-4 font-display text-2xl leading-tight" data-id="element-976" data-mp="1nq0jfckyrset">{product.name}</h3>
                </Link>
                <p className="mt-1 text-[11px] font-bold uppercase tracking-wide2 text-black/45" data-id="element-977" data-mp="1xm3sz3i5atbs">
                  {product.producer} · {formatPrice(product.price)}
                </p>
                <Note className="mt-2 block !text-lg" data-id="element-978" data-mp="1spdf8mttc9tj">{product.tip}</Note>
              </li>
            </Reveal>)}
        </ol>

        <Reveal data-id="element-979" data-mp="342pe0japu28u">
          <p className="mt-14 flex items-center gap-3 text-[12px] font-bold uppercase tracking-wide2" data-id="element-980" data-mp="3414iorgkuf9x">
            <Rating value={4.5} data-id="element-981" data-mp="3bkx9m0atn0ch" />
            <span className="text-black/50" data-id="element-982" data-mp="3bnrufsxqyn6f">Så här sätter vi betyg: vi äter, vi betalar, vi tycker.</span>
          </p>
        </Reveal>
      </section>
    </div>;
}